export default __webpack_public_path__ + "static/media/loadingScreen.e1101965.gif";